import { render, staticRenderFns } from "./InformarPago.vue?vue&type=template&id=9c5864f0&scoped=true"
import script from "./InformarPago.vue?vue&type=script&lang=js"
export * from "./InformarPago.vue?vue&type=script&lang=js"
import style0 from "./InformarPago.vue?vue&type=style&index=0&id=9c5864f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5864f0",
  null
  
)

export default component.exports